module.exports = __webpack_public_path__ + "assets/img/popup_chart-2.b77b8ffb.png";